import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './DeviceCategory.scss';
const highlightStyle = {
    backgroundColor: 'rgba(0, 140, 255, 0.1)',
    border: '1px solid #008CFF',
};
const normalStyle = {
    backgroundColor: '#FFFFFF',
    border: '1px solid #D5D8DF',
};
const DeviceCategory = (props) => {
    return (_jsxs("div", Object.assign({ className: "DeviceCategory", style: props.isRefined ? highlightStyle : normalStyle }, { children: [_jsx("img", { className: "device", src: props.image, alt: props.alt }, void 0), _jsx("p", Object.assign({ className: "imageLabel" }, { children: props.label }), void 0)] }), void 0));
};
export default DeviceCategory;
